import * as R from 'ramda';
import { PriceValues } from '../ProductTypes';
import { PriceValue, PricesConfig } from './interfaces/product-prices.interfaces';

const validatePriceAndGetMin = (currentPrice: PriceValue, prevPrice: PriceValue) => {
  if (R.isNil(currentPrice) || currentPrice < 0 || Number.isNaN(currentPrice)) {
    return prevPrice;
  }

  if (R.isNil(prevPrice)) {
    return currentPrice;
  }

  return Math.min(currentPrice, prevPrice);
};

const validatePriceAndGetMax = (currentPrice: PriceValue, prevPrice: PriceValue) => {
  if (R.isNil(currentPrice) || currentPrice < 0 || Number.isNaN(currentPrice)) {
    return prevPrice;
  }

  if (R.isNil(prevPrice)) {
    return currentPrice;
  }

  return Math.max(currentPrice, prevPrice);
};

export const mapPrices = (previous: PricesConfig, current: PriceValues) => ({
  minWholesalePrice: validatePriceAndGetMin(current.wholesalePrice, previous.minWholesalePrice),
  maxWholesalePrice: validatePriceAndGetMax(current.wholesalePrice, previous.maxWholesalePrice),
  minPromotionalPrice: validatePriceAndGetMin(
    current.promotionalPrice,
    previous.minPromotionalPrice,
  ),
  maxPromotionalPrice: validatePriceAndGetMax(
    current.promotionalPrice,
    previous.maxPromotionalPrice,
  ),
  hasPromotion:
    previous.hasPromotion || (!R.isNil(current.promotionalPrice) && current.promotionalPrice >= 0),
  minRetailPrice: validatePriceAndGetMin(current.retailPrice, previous.minRetailPrice),
  maxRetailPrice: validatePriceAndGetMax(current.retailPrice, previous.maxRetailPrice),
});

export const initialPricesState: PricesConfig = {
  minWholesalePrice: Number.POSITIVE_INFINITY,
  maxWholesalePrice: Number.NEGATIVE_INFINITY,
  minPromotionalPrice: undefined,
  maxPromotionalPrice: undefined,
  hasPromotion: false,
  minRetailPrice: undefined,
  maxRetailPrice: undefined,
};
export const emptyPricesConfig = {
  minWholesalePrice: undefined,
  maxWholesalePrice: undefined,
  minPromotionalPrice: undefined,
  maxPromotionalPrice: undefined,
  hasPromotion: false,
  minRetailPrice: undefined,
  maxRetailPrice: undefined,
};
